<style lang="less" scoped>
.content {
  margin: 30px 50px;
  position: relative;

  .loading {
    position: absolute;
    left: 45%;
    top: 150px;
  }

  .member {
    margin-top: 20px;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-row-gap: 5px;
    background-color: @white;

    /deep/.ant-btn {
      width: 60px;
      height: 24px;
      line-height: 24px;
      border: 1px solid @primary-color;
      background: #fff;
      color: @primary-color;
      float: right;
    }

    // .member-item{
    //   margin:0 5px;
    //   img{
    //     width:40px;
    //     height:40px;
    //     border:2px solid #CCC;
    //     border-radius:50%;
    //     margin:5px 10px;
    //   }
    //   .owner{
    //     color: blue !important;
    //     font-weight: bold;
    //   }
    //   .teacher::before{
    //     content: '🌷';
    //     color: @primary-color;
    //     font-size:1.2em;
    //   }
    //   .inClass{
    //     border:2px solid green;
    //   }
    // }
    .owner {
      color: blue !important;
      font-weight: bold;

      .active {
        display: none;
      }

      .active1 {
        display: none;
      }

      .del {
        display: none;
      }
    }

    .teacher::before {
      content: '🌷';
      color: @primary-color;
      font-size: 1.2em;
    }

    .inClass {
      border: 2px solid green;
    }

    .del {
      margin-right: 20px;
      float: right;
      color: #db5647;
      cursor: pointer;
    }

    .active {
      margin-right: 15px;
      float: right;
      color: #ccc;
      cursor: pointer;
      margin-top: 4px;
    }

    .active1 {
      margin-right: 15px;
      float: right;
      color: red;
      cursor: pointer;
      float: right;
      margin-top: 4px;
    }
  }

  /deep/.ant-list {
    width: 680px;
  }

  /deep/.ant-list-item {
    padding: 15px 0px 10px 0px
  }

  /deep/.ant-pagination {
    text-align: center;
  }

  /deep/.ant-list-vertical .ant-list-item-meta {
    margin-bottom: 0px;
  }

  /deep/.ant-list-item-meta-avatar {
    margin-right: 16px;
    margin-top: -6px;
  }
}

.addStudent {
  width: 220px;
  height: 44px;
  font-size: 20px;
  box-sizing: border-box;
  line-height: 44px;
  text-align: center;
  color: @primary-color;
  border: 1px solid @primary-color;
  border-radius: 12px;
  margin: auto;
  cursor: pointer;
}

.user-img {
  width: 40px;
  height: 40px;
  border-radius: 50%;
}
</style>
<template>
  <div>
    <div class="content">
      <a-spin class="loading" v-show="loading" />
      <!-- <div>头像绿色：在班级；头像灰色：不在班级；名称带🌷老师；名称蓝色加粗：群管理员</div> -->
      <div class="member">
        <a-list itemLayout="vertical" :pagination="pagination" :data-source="members">
          <a-list-item slot="renderItem" slot-scope="item">
            <a-list-item-meta>
              <div slot="title" :class="{ owner: item.owner, teacher: item.isTea }">
                <img class="user-img" v-if="item.photo && item.photo != null"
                  :src="resBasePath+ item.photo" alt="">
                <img class="user-img" v-else src="imgs/stu-photo.png" alt="">
                <span style="margin-left: 15px;">{{ item.userName || item.member || item.owner }}</span>
                <a-button type="primary" v-if="item.isGroupLeader == 1">组长</a-button>
              </div>
              <!-- <a-avatar  slot="avatar" :src="item.photo" /> -->

            </a-list-item-meta>
          </a-list-item>
        </a-list>
      </div>
    </div>
    <div class="addStudent" @click="invitStudent">邀请学生加入</div>
    <a-modal title="选择学生" width='1000px' :visible="addStuModel" @cancel="handleCancel" @ok="invitOk" destroyOnClose>
      <div class="studentList" style="min-height:120px;max-height:300px;overflow-y:scroll;">
        <a-radio-group name="radioGroup" :default-value="1" @change="changeStu">
          <a-row>
            <a-col style="height:40px;line-height:40px;" :span="8" v-for="(item, index) in classAllMember" :key="index">
              <a-radio :value="item">
                <template>
                  <img v-if="item.photo != null" style="width:30px;height:30px;border-radius:50%;margin:0px 10px;"
                    :src="resBasePath+ item.photo" alt="">
                  <img v-if="item.photo == null" style="width:30px;height:30px;border-radius:50%;margin:0px 10px;"
                    src="imgs/stu-photo.png" alt="">
                  <span style="display:inline-block;width:100px;" class="userName">{{ item.userName }}</span>
                </template>
              </a-radio>
            </a-col>
          </a-row>
        </a-radio-group>
      </div>
    </a-modal>
  </div>
</template>

<script>
import WebIM from 'utils/WebIM'
import shareState from 'utils/shareState.js'
export default {
  name: 'Member',
  data () {
    return {
      shareData: shareState.state,
      resBasePath: this.$userINfoBasePath+ '/' ,
      admin: '',
      members: [], // 班级成员+IM群组成员
      teachers: [], // 班级教师
      groupOwner: [], // 群管理员
      groupId: '',
      classAllMember: [], //班级所有的学生
      groups: [], // 获取所有的群组
      loading: false,
      pagination: {
        onChange: page => {
          //console.log(page);
        },
        pageSize: 10,
      },
      addStuModel: false,
      studentId: '',// 邀请某个学生的ID
    }
  },
  watch: {
    $route () {
      this.getClassInfo()
      this.getClassGroupStu()
    },
  },
  mounted () {
    this.getClassInfo()
    this.getClassGroupStu()
    // console.log(this.$route)
    // this.getClassMembers()
  },
  methods: {
    getMembers () {
      // 将IM群组成员与班级成员信息进行合并。
      this.loading = true
      const groupid = this.$route.params.groupid
      //const classMembers = this.getClassMembers()
      const vm = this
      const options = {
        groupId: groupid, // 群组id
        success: function (res) {
          vm.admin = res.data[0].owner
          vm.members = res.data[0].affiliations.reverse()
          // vm.members = res.data[0].affiliations.reduce((pre, cur) => {
          //   const target = pre.find(ee => ee.id === cur.member)
          //   if (target) {
          //     Object.assign(target, cur)
          //   } else {
          //     pre.push(Object.assign(cur, { inClass: false, photo: 'imgs/logo.png' }))
          //   }
          //   return pre
          // }, classMembers)
          vm.loading = false
        },
        error: function (e) {
          vm.$message.error('获取群组成员失败！')
        }
      }
      WebIM.conn.getGroupInfo(options)

    },
    // getClassMembers () {
    //   this.$fetch({
    //     url: this.$baseUrl + 'ebook/group/common/getMyClass'
    //   }).loading(
    //     () => (this.loading = true),
    //     () => (this.loading = false)
    //   ).done(res => {
    //     this.members = res.resultData[0].students
    //     this.$forceUpdate()
    //   //   if (myClass.length > 0 && myClass[0].students.length>0) {
    //   //   const classMembers = myClass[0].students.map(s => {
    //   //     const photo = s.photo&&s.photo!=null ? this.$userINfoBasePath + '/' + s.photo : 'imgs/stu-photo.png'
    //   //     return Object.assign(s, { photo, inClass: true })
    //   //   })
    //   //   classMembers.unshift(this.getTeacher(myClass[0])) // 在数组前追加老师
    //   //   this.members = classMembers
    //   // }

    //   })
    // },
    getTeacher (myClass) {
      if (myClass) {
        return {
          id: myClass.teaId,
          userName: myClass.teaName,
          isTeacher: true,
          photo: this.$store.state.userInfo.photo ? this.$userINfoBasePath + '/' + this.$store.state.userInfo.photo : 'imgs/teacher.png',
          inClass: true
        }
      }
      return null
    },
    getClassInfo () {
      // 获取群组信息
      let tagId = this.$route.params.groupid
      let _this = this
      _this.groups = this.$store.state.groupLists
      console.log(this.shareData.groupLists)
      console.log(_this.groups)
      console.log(tagId)
      // 获取小组id
      const group = _this.groups.filter(g => g.groupTag === tagId)[0]
      _this.groupId = group.id
      // _this.groups.forEach(item => {
      //   if (item.groupTag === tagId) {
      //     _this.classAllMember = item.students
      //   }
      // })
      // if (_this.groups.length > 0) {
      //   _this.members = _this.groups.filter(c => c.groupTag === _this.$route.params.groupid)[0].students
      //   _this.groupId = _this.groups.filter(c => c.groupTag === _this.$route.params.groupid)[0].id
      // } else {
      //   _this.members = []
      // }
    },
    getClassData () {
      // 根据班级id,获取班级学生列表
      const _this = this
      _this.$fetch({
        url: _this.$baseUrl + 'ebook/class/common/v2/getV2MyClassStu',
        body: { classId: localStorage.getItem('classID') }
      })
        .done((res) => {
          if (res && res.success && res.resultCode === 0) {
            const stu = res.resultData.filter((msg) => msg.isTea === 0)
            const memberId = _this.members.map(item => item.userId)
            // console.log(stu)
            // console.log(memberId)
            _this.classAllMember = stu.filter(item => !memberId.includes(item.id))
            //  console.log('getV2MyClassStu')
            //  console.log(res)
          }
        })
    },
    messForbden (item) {
      // 班级禁言
      this.groupId = this.$route.params.groupid // 获取群组ID
      const param = {
        groupTag: this.groupId,
        userId: item.id
      }
      let _this = this
      const url = item.isForbidden == 0 ? 'ebook/group/common/setForbiddenWords' : 'ebook/group/common/cancelForbiddenWords'
      _this.$fetch({
        url: _this.$baseUrl + url,
        body: param
      }).loading(
        () => { _this.loading = true },
        () => { _this.loading = false }
      ).done(res => {
        if (res && res.success && res.resultCode === 0) {
          _this.getClassInfo()
          _this.getClassGroupStu()
        }
      })
    },
    handleCancel () { //取消
      this.addStuModel = false
    },
    invitStudent () { //邀请学生
      this.addStuModel = true
    },
    invitOk () { //邀请学生确定
      const param = {
        groupId: this.groupId,
        // studentId: this.studentId
        userId: this.studentId
      }
      this.$fetch({
        url: this.$baseUrl + 'ebook/class/common/inviteStudentJoinGroup',
        body: param
      }).loading(
        () => { this.loading = true },
        () => { this.loading = false }
      ).done(res => {
        if (res && res.success && res.resultCode === 0) {
          this.addStuModel = false
          this.getClassInfo()
          this.getClassGroupStu()
        }
      })
    },
    changeStu (e) { //选择学生
      this.studentId = e.target.value.id
    },
    getClassGroupStu () {
      // 根据小组id 获取小组成员--重新拆分接口，减少原大接口耗时
      const _this = this
      _this.$fetch({
        url: _this.$baseUrl + 'ebook/class/common/v2/getClassGroupStu',
        body: { id: this.groupId }
      })
        .done((res) => {
          if (res && res.success && res.resultCode === 0) {
            _this.members = res.resultData
            console.log('getClassGroupStu')
            console.log(res)
            // 获取班级
            this.getClassData()
          }
        })
    }

  }
}
</script>
